export default __webpack_public_path__ + "static/media/Layout_Compensation_Incentive_Program.9b7d53ad.xlsx";